module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/caserta.63c55c7413aa838a506e9c22fda458ed.jpg";